import React, { useState } from 'react';
import { Text, Dialog, Button, Flex, Pane } from '@leverege/ui-elements';
import { Attributes, AttributeDetailRenderer, DataSources } from '@leverege/ui-attributes';
import classnames from 'classnames';
import S from './Renderer.css';
import ResourceImageValueComponent from "./ResourceImageValueComponent.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class ResourceImageDetailRenderer extends AttributeDetailRenderer {
  getValueComponent([value], valueSyle, obj) {
    const {
      objectType,
      attrName,
      objectFit,
      imageHeight,
      imageWidth,
      imagePaneVariant,
      percentageHeight,
      percentageWidth,
      imageBackgroundColor,
      value: {
        emptyValue,
        emptyIcon
      },
      dialog: {
        titleIcon,
        objectFit: popupObjectFit,
        imageWidth: popupImageWidth,
        imageHeight: popupImageHeight
      } = {}
    } = this.detail;
    const attribute = Attributes.getAttribute(attrName, objectType);
    const {
      name
    } = this;
    if (value === emptyValue || !value) {
      return /*#__PURE__*/_jsx(Pane, {
        variant: imagePaneVariant,
        children: /*#__PURE__*/_jsx(Text, {
          className: classnames(S.emptyValue, S.win, S.really),
          icon: emptyIcon,
          iconOpts: {
            style: {
              fontSize: '32px'
            }
          },
          children: emptyValue
        })
      });
    }
    const childStyle = {
      objectFit,
      height: '100%',
      width: '100%',
      backgroundColor: imageBackgroundColor
    };
    const parentStyle = {
      height: imageHeight && `${imageHeight}${percentageHeight ? '%' : 'px'}`,
      width: imageWidth && `${imageWidth}${percentageWidth ? '%' : 'px'}`,
      overflow: 'hidden'
    };
    const popupImageStyle = {
      objectFit: popupObjectFit,
      height: popupImageHeight && `${popupImageHeight}px`,
      width: popupImageWidth && `${popupImageWidth}px`
    };
    const delegate = DataSources.getActions({
      ...obj,
      ref: obj?.ref?.replace(`/${obj.id}`, '')
    });
    const imagePath = `resourceImage/${name.split('.').filter((v, i) => i !== 0).join('/')}`;
    const titleText = attribute.source.attribute.getString('titleDialogImage', `View ${attribute.displayName}`);
    return /*#__PURE__*/_jsx(Pane, {
      variant: imagePaneVariant,
      style: parentStyle,
      children: /*#__PURE__*/_jsx(DetailComponent, {
        value: value,
        imagePath: imagePath,
        childStyle: childStyle,
        delegate: delegate,
        titleIcon: titleIcon,
        titleText: titleText,
        popupImageStyle: popupImageStyle
      })
    });
  }
}
function DetailComponent(props) {
  const {
    value,
    imagePath,
    childStyle,
    delegate,
    titleIcon,
    titleText,
    popupImageStyle
  } = props;
  const [showDialog, setShowDialog] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      height: '100%',
      width: '100%'
    },
    onClick: e => {
      e.stopPropagation();
      setShowDialog(true);
    },
    children: [/*#__PURE__*/_jsx(ResourceImageValueComponent, {
      value: value,
      path: imagePath,
      valueStyle: childStyle,
      clientProps: {
        delegate
      }
    }), /*#__PURE__*/_jsx(Dialog, {
      bodyVariant: "dialogBody",
      bodyClassName: classnames(S.noSize, S.win, S.really),
      title: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowSpaceBetween",
        children: [/*#__PURE__*/_jsx(Text, {
          icon: titleIcon,
          variant: "dialogTitle",
          children: titleText
        }), /*#__PURE__*/_jsx(Button, {
          onClick: () => setShowDialog(false),
          variant: "closeDialog"
        })]
      }),
      show: showDialog,
      onClose: () => setShowDialog(false),
      children: /*#__PURE__*/_jsx(Flex, {
        align: "center",
        justify: "center",
        children: /*#__PURE__*/_jsx(ResourceImageValueComponent, {
          showCreatedAt: true,
          value: value,
          path: imagePath,
          valueStyle: popupImageStyle,
          clientProps: {
            delegate
          }
        })
      })
    })]
  });
}